export default "__VITE_ASSET__BmG_N7kx__"